package com.solevo.dist.application.entities.countries.service

import com.solevo.dist.application.models.countries.CountriesData
import com.solevo.libraries.entities.country.CountryBasics
import com.solevo.libraries.entities.country.RemoteCountryService

class CountryRemoteService: RemoteCountryService {

    override suspend fun fetchCountriesLegalEntities(): Result<List<RemoteCountryService.CountryPayload.LegalEntity>> {
        return runCatching {
            CountriesData.countries.map { country ->
                RemoteCountryService.CountryPayload.LegalEntity(
                    id = country.isoCode,
                    isoCode = CountryBasics.IsoCode(twoCharacters = country.isoCode, threeCharacters = country.isoCode),
                    name = country.name,
                    loyaltyProgramId = 0,
                    gtcHtml = ""
                )
            }
        }
    }

    override suspend fun fetchCountriesPhoneCallingCodes(): Result<List<RemoteCountryService.CountryPayload.PhoneCallingCode>> {
        return runCatching {
            CountriesData.countries.map { country ->
                RemoteCountryService.CountryPayload.PhoneCallingCode(
                    isoCode = CountryBasics.IsoCode(twoCharacters = country.isoCode, threeCharacters = country.isoCode),
                    name = country.name,
                    callingCode = country.phoneCode,
                    regexPattern = country.regexPattern
                )
            }
        }
    }

    override suspend fun fetchCountryByIpAddress(): Result<RemoteCountryService.CountryPayload.IPAddress> {
        return runCatching {
            RemoteCountryService.CountryPayload.IPAddress(
                countryCode = "ci"
            )
        }
    }
}